.button {
    display: block;
    width: 100%;
    border-radius: var(--mantine-radius-md);
    color: var(--mantine-color-text);
}

.button:hover {
    background-color: var(--mantine-color-gray-0);
}

[data-mantine-color-scheme='dark'] .button:hover {
    background-color: var(--mantine-color-dark-6);
}

.button a:hover {
    color: var(--mantine-color-anchor);
}

.button:focus,
.button:focus-visible {
    outline: none;
}
